import queryString from "query-string";

export const getNext = ({ route, search, hash }) => {
  let newRoute = route;
  const parsedSearch = queryString.parse(search);
  if (parsedSearch.next) {
    newRoute += `?next=${parsedSearch.next}`;
  }
  if (hash) {
    newRoute += hash;
  }

  return newRoute;
};

/**
 * 
 * @param next example: v2/settings/
 * @param urlToRedirect example: console.waterbaloonz.xyz
 * @param forcedTenantId example 123
 * @returns console.waterbaloonz.xyz or console.waterbaloonz.xyz/v2/settings/ or even console.waterbaloonz.xyz/v2/settings?tenantId=123
 */
export const extractNextRoute = ({ next, urlToRedirect, forcedTenantId }) => {
  let finalRoute = urlToRedirect;
  if (next) {
    let nextRoute = `/${next}`;
    nextRoute = nextRoute.replace(/\/\//g, "/");

    if (forcedTenantId) {
      nextRoute += `?tenantId=${forcedTenantId}`;
    }
    finalRoute += nextRoute;
  }
  return finalRoute;
};

// checks if there is tenantId in query and return it
export const getQueryTenantId = () => {
    const query = queryString.parse(location.search);
    return query?.tenantId ?? null;
}
